import { component } from 'picoapp';
import customScrollbar from 'utils/custom-scrollbar';

export default component(async (node) => {
  const scrollElement:HTMLElement = node.querySelector('[hide-scrollbar]');
  const scrollbar:HTMLElement = node.querySelector('.scrollbar__slider--wrapper');
  const scrollIndicator:HTMLElement = node.querySelector('.scrollbar__slider--indicator');
  customScrollbar(scrollElement, scrollbar, scrollIndicator);
});
